/**
 * planCommandMonitorBeforeSelectTopicModule Module
 *
 * Description: 策划中心 指挥监测中心 编前选题管理
 * Author: xxx 2017-7-18
 */
"use strict";
angular.module("planCommandMonitorBeforeSelectTopicModule", [])
    .controller('planCommandMonitorBeforeSelectTopicCtrl', ['$scope', 'trsHttpService', "$q", '$filter', 'planCommandMonitorService','modalDialog',
        function($scope, trsHttpService, $q, $filter, planCommandMonitorService,modalDialog) {
            initStatus();
            initData();
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                requestData();
            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.data = {};
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: '',
                    PAGECOUNT: '',
                    copyCurrPage: 1,
                }
            }
            /**
             * [share description] 打开分享弹窗
             * @param  {[type]} uurl [分享链接地址]
             * @param  {[type]} id   [场景ID]             
             */
            $scope.shareBef = function(id) {
                planCommandMonitorService.share(id, '7', "复制链接和密码");
            };
            $scope.newOpenBeforeSelect=function(id,title){
                planCommandMonitorService.newBeforeSelectTop(id,title).then(function(){
                    requestData();
                });
            };
            /* 
             * [requestData description:获取数据]
             */
            function requestData() {
                $scope.params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'preSelectedSearch',
                    "method": 'searchSelecedTitles',
                    "page_size": $scope.page.PAGESIZE,
                    "page_no": $scope.page.copyCurrPage - 1
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "post").then(function(data) {
                    $scope.data = data.mapResult.content.content;
                    $scope.page.PAGECOUNT = data.mapResult.content.totalPages;
                    $scope.page.ITEMCOUNT = data.mapResult.content.totalElements;
                });
            }
            $scope.$on('beforeSelectTop',function(event,data){
                requestData();
            });
            /**
             * [timeStamp:将日期字符串转化为标准格式]
             */
            $scope.timeStamp = function(info) {
                return $filter("date")(info.updateTime, "yyyy-MM-dd HH:mm:ss").toString();
            };
            /**
             * [selectPageNum description] 选择每页显示的数据数量
             * @return {[type]} [description]
             */

            $scope.selectPageNum = function() {
                $scope.page.copyCurrPage = 1;
                // $scope.page.PAGESIZE = $scope.page.CURRPAGE - 1;
                // $scope.params.page_size = $scope.page.PAGESIZE;
                requestData();
            };
            /*
             *[pageChanged description:跳转页面]
             */
            $scope.pageChanged = function() {
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
                $scope.params.page_no = $scope.page.copyCurrPage;
                requestData();
            };
            /*
             *[jumpToPage description:跳转到指定页面]
             */
            $scope.jumpToPage = function() {
                if (!$scope.page.copyCurrPage) return;
                if ($scope.page.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.page.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.page.copyCurrPage;
                requestData();
            };
            /**
             * [scan description:用于打开查看链接]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.scan = function(item) {
                window.open(item.url);
            };
            /**
             * [deleteConfirm description:扇窗户提示弹出框]
             * @return {[type]} [description]
             */

            /**
             * [deleteSelectList description:实现删除功能]
             * @return {[type]} [description]
             */
            $scope.deleteSelectList = function(item) {
                var delParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'preSelectedSearch',
                    "method": 'delete',
                    "id": item.id
                };

                modalDialog.confirmModal("删除提示", "是否确认删除？",
                    function() {
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), delParams, 'post').then(function(data) {
                            requestData();
                        });
                    },
                    function() {

                    });

            };
        }
    ]);